const drawArrow = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M8 2.144 16 0l-2.143 8-2.428-2.428L1 16 0 15 10.428 4.57z" clip-rule="evenodd"/></svg>',
};

export { drawArrow as default };
